import {
  getClientTimeZone,
  formatDateTime,
  formatTimeSpan,
  Dateable,
  TimeSpanFormatter,
  useDate,
  ensureDate,
} from "../..";

interface RelativeTimeProperty {
  date: Dateable;
  formatter?: TimeSpanFormatter;
  hasSuffix?: boolean;
}

const RelativeTime = (props: RelativeTimeProperty) => {
  const { date, formatter = formatTimeSpan, hasSuffix } = props;

  // Get timezone from AppProvider (if exists)
  const { timezone } = useDate();

  // Check if the date is valid
  const dateObject = ensureDate(date);
  if (Number.isNaN(dateObject.getTime())) {
    return "";
  }

  // fallback to client timezone then to UTC if that fails
  const clientTimezone = timezone || getClientTimeZone() || "UTC";

  const formattedISODate = formatDateTime(date, "iso", clientTimezone);

  return (
    <time dateTime={formattedISODate} title={formattedISODate}>
      {formatter(Date.now(), date, hasSuffix !== false)}
    </time>
  );
};

export default RelativeTime;
